
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hW2zm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9809854e82c108ca$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $9809854e82c108ca$export$2e2bcd8739ae039 = {
    'fabric.elements.mentions.team.meantion.highlight.close.button.tooltip': "Zru\u0161i\u0165",
    'fabric.elements.mentions.team.mention.highlight.description': "Informujte ka\u017Ed\xe9ho jedn\xfdm kliknut\xedm. Nem\xe1te t\xedm?",
    'fabric.elements.mentions.team.mention.highlight.description.link': "Vytvori\u0165.",
    'fabric.elements.mentions.team.mention.highlight.title': "Spomen\xfa\u0165 t\xedm",
    'fabric.mention.error.defaultAction': "Sk\xfaste to znova o chv\xed\u013Eu",
    'fabric.mention.error.defaultHeadline': "Vyskytol sa probl\xe9m",
    'fabric.mention.error.differentText': "Sk\xfaste zada\u0165 in\xfd text",
    'fabric.mention.error.loginAgain': "Sk\xfaste sa odhl\xe1si\u0165 a n\xe1sledne prihl\xe1si\u0165",
    'fabric.mention.noAccess.label': "\u017Diadny pr\xedstup",
    'fabric.mention.noAccess.warning': "Pou\u017E\xedvate\u013E {name} sa neupozorn\xed. preto\u017Ee nem\xe1 pr\xedstup",
    'fabric.mention.unknow.user.error': "Nezn\xe1my pou\u017E\xedvate\u013E {userId}"
};

});


//# sourceMappingURL=sk.b538319e.js.map
